<template>
  <div class="home">
    <div class="img wow fadeIn">
      <img src="../asset/aike/map.png" alt />
      <div class="list">
        <!-- 德国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a href="https://www.ductstation.co.uk/" target="_blank">Ductstation</a>
          </div>
        </div>
        <!-- 奥地利 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>HVAC Tech Service</a>
          </div>
        </div>
        <!-- 意大利 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a href="http://www.entalpiaeurope.eu" target="_blank">Entalpia Eu</a>
          </div>
        </div>
        <!-- 西班牙 -->
        <div class="region-list active postition online-node">
          
        </div>
        <!-- 英国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>Entalpia Eu Thailand</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>Halochem</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>Entalpia Eu Vietnam</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>{{$t('contact').mapname[8]}}</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a target="_blank">{{$t('contact').mapname[0]}}</a>
            <a href="http://www.icoolglobal.com/" target="_blank">{{$t('contact').mapname[1]}}</a>
            <a>{{$t('contact').mapname[2]}}</a>
            <a href=" http://sino-hvac.com/" target="_blank">{{$t('contact').mapname[3]}}</a>
            <a>{{$t('contact').mapname[4]}}</a>
            <a href="http://comfy.sansg.com/" target="_blank">{{$t('contact').mapname[5]}}</a>
            <a href="http://aiqini.sansg.com/" target="_blank">{{$t('contact').mapname[6]}}</a>
            <a>{{$t('contact').mapname[7]}}</a>
          </div>
          <div class="line">
            <div class="h_line"></div>
            <div class="x_line"></div>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>ICOOL Korea</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>ICOOL Japan</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>ICOOL Pacific</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>Uni Refrigeracion</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a href="http://www.icoolproductsusa.com" target="_blank">ICOOL USA</a>
          </div>
        </div>
        <!-- 法国 -->
        <div class="region-list active postition online-node">
          <div class="area-box">
            <span class="dot"></span>
            <!-- <span class="pulse delay-06"></span>
            <span class="pulse delay-05"></span>
            <span class="pulse delay-04"></span> -->
          </div>
          <div class="show-regin">
            <a>ICOOL Canada</a>
          </div>
        </div>
      </div>
    </div>
    <div class="img img2">
      <img src="../asset/aike/pmap.jpg" alt="">
    </div>
    <div class="main">
      <div class="t1 wow fadeInUp">
        <p>{{$t('contact').text0}}</p>
        <p>{{$t('contact').text1}}</p>
      </div>
      <div class="mCon wow fadeInUp">
        <div class="map">
          <Map></Map>
        </div>
        <div class="address wow fadeInUp">
          <div class="item" v-for="(item,index) in list" :key="index">
            <div class="pic">
              <img :src="item.img" alt />
            </div>
            <div class="text">
              <p>{{item.title}}</p>
              <p>{{item.title2}}</p>
            </div>
          </div>
        </div>

        <!-- <div class="allImgs wow fadeInUp">
          <swiper :options="swiperOption" ref="mySwipers2" class="swiper2">
            <swiper-slide class="item" v-for="(item,index) in data.address" :key="index">
              <div class="info">
                <div class="pic">
                  <img src="../asset/aike/wz.png" alt />
                  <img src="../asset/aike/wzb.png" alt />
                </div>
                <p class="p1">{{item.title}}</p>
                <p class="p2">{{item.description}}</p>
              </div>
            </swiper-slide>
          </swiper>
          <div class="btn prev"></div>
          <div class="btn next"></div>
        </div>-->
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Map from "../components/map";
import foot from "@/components/foot.vue";
import Scrollbar from "smooth-scrollbar";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import { getContact } from "../util/lang";

export default {
  name: "contact",
  data() {
    return {
      scrollbar: "",
      data: "",
      list: [
        {
          img: require("../asset/aike/a1.png"),
          title: "客服电话",
          title2: "0574-87654666",
        },
        {
          img: require("../asset/aike/a2.png"),
          title: "公司网址",
          title2: "www.icoolglobal.cn",
        },
        {
          img: require("../asset/aike/a3.png"),
          title: "品牌合作",
          title2: "hvac@icoolglobal.com",
        },
      ],
      swiperOption: {
        slidesPerView: 4, //一行显示3个
        init: false,
        spaceBetween: 60,
        loop: true,
        speed: 1000,
        navigation: {
          nextEl: ".allImgs .next",
          prevEl: ".allImgs .prev",
        },
      },
    };
  },
  mounted() {
    Scrollbar.initAll(document.getElementById("scroller-wrapper"));
    this.scrollbar = Scrollbar.get(document.getElementById("scroller-wrapper"));
    this.scrollbar.scrollTo(0, 1);
    this.scrollbar.addListener((status) => {
      window.pageYOffset = this.scrollbar.scrollTop;
    });
    if(this.$i18n.locale =='en'){
      this.list=[
        {
          img: require("../asset/aike/a1.png"),
          title: "Customer Service Number",
          title2: "+86 57487432748",
        },
        {
          img: require("../asset/aike/a2.png"),
          title: "Company Web link",
          title2: "www.icoolglobal.cn",
        },
        {
          img: require("../asset/aike/a3.png"),
          title: "Corporate Brand",
          title2: "hvac@icoolglobal.com",
        }
      ]
    }
    setTimeout(() => {
      this.getContent();
    }, 100);
  },
  components: { foot, swiper, swiperSlide, Map },
  methods: {
    getContent() {
      const url = `${getContact()}`;
      this.$axios.get(url).then((res) => {
        this.data = res.data;
        this.$refs.mySwipers2.swiper.init();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  .img {
    width: 100%;
    padding: 60px auto;
    position: relative;
    animation-duration: 2s;
    img {
      width: 100%;
      display: inline-block;
      object-fit: contain;
      margin-top: -86px;
    }
    img:nth-child(2) {
      display: none;
    }
    .list {
      .postition {
        .show-regin {
          span {
            left: 11px;
            top: -6px;
          }
        }
      }
      .postition:nth-child(1) {
        left: 15%;
        top: 35%;
        .show-regin {
          left: -72px;
          top: -23px;
        }
      }
      .postition:nth-child(2) {
        left: 16%;
        top: 36%;
        .show-regin {
          left: -8px;
          top: 17px;
        }
      }
      .postition:nth-child(3) {
        left: 20%;
        top: 34%;
        .show-regin {
          left: 18px;
        }
        .area-box{
            .dot{
              background-color:#c70118;
            }
        }
      }
      .postition:nth-child(4) {
        left: 24%;
        top: 31%;
        .show-regin {
          left: 18px;
        }
      }
      .postition:nth-child(5) {
        left: 37%;
        top: 54%;
        .show-regin {
          left: -150px;
          top: -11px;
        }
      }
      .postition:nth-child(6) {
        left: 38%;
        top: 57%;
      }
      .postition:nth-child(7) {
        left: 39%;
        top: 51%;
        .show-regin {
          left: -148px;
          top: -11px;
        }
      }
      .postition:nth-child(8) {
        left: 41%;
        top: 49%;
        .show-regin {
          left: -165px;
    top: -18px;
        }
      }
      .postition:nth-child(9) {
        left: 42%;
        top: 46%;
        .area-box{
            .dot{
                width: 20px;
                height: 20px;
                top: -3px;
                left: -3px;
              
            }
        }
        .show-regin {
          left: 100px;
          top: -54px;
          a{
            display: inline-block;
            width: unset;
            padding: unset;
          }
        }
      }
      .postition:nth-child(10) {
        left: 43%;
        top: 42%;
        .show-regin {
          left: -110px;
          top: -10px;
        }
      }
      .postition:nth-child(11) {
        left: 46%;
        top: 40%;
        .show-regin {
          left: -110px;
          top: -17px;
        }
      }
      .postition:nth-child(12) {
        left: 47%;
        top: 73%;
        .show-regin {
          left: -110px;
          top: -10px;
        }
        .area-box{
            .dot{
                background-color:#c70118;
              
            }
        }
      }
      .postition:nth-child(13) {
        left: 71%;
        top: 49%;
        .show-regin{
          left: 17px;
        }
      }
      .postition:nth-child(14) {
        left: 73%;
        top: 43%;
        .show-regin{
          left: 17px;
        }
        .area-box{
            .dot{
              background-color:#c70118;
            }
        }
      }
      .postition:nth-child(15) {
        left: 76%;
        top: 36%;
        .show-regin{
          left: 17px;
        }
      }
      .postition:nth-child(16) {
        left: 82%;
        top: 27%;
      }
      .postition:nth-child(17) {
        left: 78%;
        top: 25%;
      }
      .postition:nth-child(18) {
        left: 73%;
        top: 30%;
      }
      .postition:nth-child(19) {
        left: 73%;
        top: 36%;
      }
      .region-list {
        position: absolute;
      }
      @keyframes warn {
        0% {
          transform: scale(0);
          opacity: 1;
        }
        100% {
          transform: scale(1);
          opacity: 0;
        }
      }
      .area-box {
        .dot {
          position: absolute;
          left: 2px;
          top: 2px;
          width: 10px;
          height: 10px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background: #0c4ea2;
          opacity: 1;
          filter: alpha(opacity=100);
          animation: point 1s linear alternate infinite;
        }
        @keyframes point {
          0%{
            opacity: 1;
            // filter: blur(0);
          }
          100%{
            opacity: 0;
            // filter: blur(5px);
          }
        }
        .dot2 {
          position: absolute;
          left: 2px;
          top: 2px;
          width: 10px;
          height: 10px;
          -webkit-border-radius: 50%;
          -moz-border-radius: 50%;
          border-radius: 50%;
          background: #0c4ea2;
          opacity: 1;
          filter: alpha(opacity=100);
        }
        .pulse {
          position: absolute;
          top: -28px;
          left: -28px;
          height: 66px;
          width: 66px;
          border: 2px solid #0c4ea2;
          -webkit-border-radius: 48px;
          -moz-border-radius: 48px;
          border-radius: 48px;
          box-shadow: 0 0 4px #0c4ea2, 0 0 10px #0c4ea2 inset;
          opacity: 0.12;
          filter: alpha(opacity=0);
          -webkit-animation: warn 2s ease-out both;
          -moz-animation: warn 2s ease-out both;
          -o-animation: warn 2s ease-out both;
          animation: warn 2s ease-out both;
          -webkit-animation-iteration-count: infinite;
          -moz-animation-iteration-count: infinite;
          -o-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
          background: 0 0;
        }
        .pulse2 {
          position: absolute;
          top: -28px;
          left: -28px;
          height: 66px;
          width: 66px;
          border: 2px solid #0c4ea2;
          -webkit-border-radius: 48px;
          -moz-border-radius: 48px;
          border-radius: 48px;
          box-shadow: 0 0 4px #0c4ea2, 0 0 10px #0c4ea2 inset;
          opacity: 0.12;
          filter: alpha(opacity=0);
          -webkit-animation: warn 2s ease-out both;
          -moz-animation: warn 2s ease-out both;
          -o-animation: warn 2s ease-out both;
          animation: warn 2s ease-out both;
          -webkit-animation-iteration-count: infinite;
          -moz-animation-iteration-count: infinite;
          -o-animation-iteration-count: infinite;
          animation-iteration-count: infinite;
          background: 0 0;
        }
        .delay-04 {
          animation-delay: 0.5s;
        }
        .delay-05 {
          animation-delay: 0.8s;
        }
        .delay-06 {
          animation-delay: 1s;
        }
      }

      .show-regin {
        position: absolute;
        left: 2px;
        height: 0;
        top: 0;
        width: 11px;
        // opacity: 0;
        transition: all 0.5s ease-in-out;
        a {
          width: 80px;
          // position: absolute;
          // left: 8px;
          // top: -11px;
          padding: 6px 10px;
          font-size: 14px;
          color: #0058a1;
          -moz-border-radius: 2px;
          -webkit-border-radius: 2px;
          border-radius: 2px;
          white-space: nowrap;
          font-family: "SOURCEHANSANSCN-LIGHT";
        }
      }
      .h_line {
        display: inline-block;
        position: absolute;
        left: 100px;
        bottom: -136px;
        width: 130px;
        height: 1px;
        background-color: #0058a1;
        opacity: .4;
      }
      .x_line {
        display: inline-block;
        position: absolute;
        left: -27px;
        bottom: -72px;
        width: 160px;
        height: 1px;
        background-color: #0058a1;
        opacity: .4;
        transform: rotate(54deg);
      }
    }
  }
  .img2{
    display: none;
  }
  .main {
    width: 100%;
    background-color: #f7f7f7;
    padding: 80px 0;
    padding-bottom: 30px;
    .t1 {
      width: 100%;
      text-align: center;
      animation-duration: 2s;
      p:nth-child(1) {
        font-size: 38px;
        font-family: "SOURCEHANSANSCN-BOLD";
      }
      p:nth-child(2) {
        color: #666666;
        font-family: "SOURCEHANSANSCN-NORMAL";
        margin-top: 20px;
      }
    }
    .mCon {
      width: 80%;
      margin: 0 auto;
      margin-top: 60px;
      animation-duration: 2s;
      .map {
        width: 100%;
        height: 500px;
      }
      .address {
        background-color: white;
        width: 90%;
        padding: 30px 5%;
        padding-bottom: 40px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        animation-duration: 2s;
        .item {
          width: 30%;
          .pic {
            padding: 20px 0;
            border-bottom: 1px solid rgba(0, 0, 0, 0.1);
            img {
              transition: all 600ms;
              cursor: pointer;
              &:hover {
                transform: rotateY(360deg);
              }
            }
          }
          .text {
            p:nth-child(1) {
              color: #343434;
              font-family: "SOURCEHANSANSCN-REGULAR";
              font-size: 23px;
              margin: 20px 0 10px 0;
            }
            p:nth-child(2) {
              font-family: "it";
              font-size: 30px;
            }
          }
        }
      }
      .allImgs {
        width: 100%;
        margin: 40px auto;
        position: relative;
        animation-duration: 2s;
        .swiper2 {
          width: 100%;
          .item {
            cursor: pointer;
            .info {
              width: 90%;
              padding: 20px 5%;
              background: rgba(255, 255, 255, 1);
              box-shadow: 0px 0px 20px 1px rgba(0, 0, 0, 0.05);
              transition: all 600ms;
              .pic {
                display: inline-block;
                position: relative;
                img {
                  transition: all 600ms;
                }
                img:nth-child(2) {
                  position: absolute;
                  left: 0;
                  top: 0;
                  width: 100%;
                  height: 100%;
                  object-fit: contain;
                  opacity: 0;
                }
              }
              .p1 {
                color: #0c4ea2;
                font-size: 23px;
                font-family: "SOURCEHANSANSCN-REGULAR";
                margin: 10px 0;
                transition: all 600ms;
              }
              .p2 {
                color: #0c4ea2;
                font-size: 18px;
                font-family: "SOURCEHANSANSCN-NORMAL";
                transition: all 600ms;
              }
              &:hover {
                background-color: #0c4ea2;
                .pic {
                  img:nth-child(1) {
                    opacity: 0;
                  }
                  img:nth-child(2) {
                    opacity: 1;
                  }
                }
                .p1,
                .p2 {
                  color: white;
                }
              }
            }
          }
        }
        .btn {
          width: 20px;
          height: 20px;
          border: 1px solid #999999;
          border-radius: 50%;
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          outline: none;
          transition: all 600ms;
          &::before {
            content: "";
            width: 6px;
            height: 6px;
            background: #999999;
            border-radius: 50%;
            display: inline-block;
            transition: all 600ms;
          }
          &:hover {
            border-color: #0c4ea2;
            &::before {
              background-color: #0c4ea2;
            }
          }
        }
        .prev {
          position: absolute;
          left: -40px;
          top: 45%;
        }
        .next {
          position: absolute;
          right: -40px;
          top: 45%;
        }
      }
    }
  }
  @media screen and (max-width: 1000px){
    padding-top: 80px;
    overflow: hidden;
    .img{
      display: none;
    }
    .img2{
      display: block;
      img{
        margin-top: 0;
      }
    }
   .main{
     padding-top: 30px;
     .t1{
       p:nth-child(1){
         font-size: 24px;
       }
       p:nth-child(2){
         width: 90%;
         margin: 0 auto;
       }
     }
     .mCon{
       width:90%;
       margin-top: 30px;
       .map{
         height:300px;
       }
       .address{
         flex-direction: column;
         .item{
           width:100%;
           .pic{
             padding: 10px 0;
             padding-top: 30px;
             img{
               width: 40px;
             }
           }
           .text{
             p:nth-child(1){
               margin-top: 10px;
               margin-bottom: 5px;
               font-size: 20px;
             }
             p:nth-child(2){
               font-size: 18px;
             }
           }
         }
       }
     }
   }
  }
}
</style>
